export default {
  template: `
    <div class="spinner" style="margin: 0 auto;">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>`,
};
